export default __webpack_public_path__ + "static/media/tabSecurityIcon.59758e74.svg";